import { Api } from 'src/api';
import { authQueries } from 'src/api/queries/queries';
import { OrderResponse } from '../../services/RequestClient';
import { defaultOptions, UseQueryOptionsObject } from '../queries.utils';
import { useMakeQuery } from '../useMakeQuery';

const useRequestQuery = (requestId: string, options?: UseQueryOptionsObject<OrderResponse>) => {
  return useMakeQuery<
    OrderResponse,
    Partial<
      Pick<
        OrderResponse,
        | 'status'
        | 'reviewed_by_customer'
        | 'reviewed_by_editor'
        | 'editor_note'
        | 'attention_text'
        | 'requested_attention_at'
      >
    >
  >([authQueries.request, requestId], () => Api.request.get(requestId), {
    staleTime: 60 * 1000,
    ...defaultOptions({
      auth: true,
      ...(options ?? {}),
    }),
  });
};

export { useRequestQuery };
